import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "centered w100",
  style: {"padding-top":"10px"}
}
const _hoisted_2 = {
  class: "mc with_white_bg",
  style: {"width":"450px"}
}
const _hoisted_3 = {
  key: 0,
  class: "with_white_bg",
  style: {"padding":"30px 25px"}
}
const _hoisted_4 = { class: "fs13 fw400 text-left" }
const _hoisted_5 = {
  class: "fs18 fw600 text-left",
  style: {"color":"#222222","padding-bottom":"13px","line-height":"1.6"}
}
const _hoisted_6 = {
  key: 1,
  width: "100%",
  class: "with_white_bg"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("tbody", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("td", {
      align: "left",
      valign: "top",
      width: "400",
      style: {"padding":"0 20px","color":"#666"}
    }, [
      /*#__PURE__*/_createElementVNode("p", { class: "mt20 ml10" }, "以下から調整ページに入り、日程を確認できます。")
    ])
  ])
], -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  class: "w100",
  style: {"background":"#fff","padding-top":"5px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MailPreviewPartsHeader = _resolveComponent("MailPreviewPartsHeader")!
  const _component_MailPreviewPartsEditContent = _resolveComponent("MailPreviewPartsEditContent")!
  const _component_MailPreviewPartsPublicRoomTable = _resolveComponent("MailPreviewPartsPublicRoomTable")!
  const _component_MailPreviewPartsSelectableMags = _resolveComponent("MailPreviewPartsSelectableMags")!
  const _component_MailPreviewPartsBlueButton = _resolveComponent("MailPreviewPartsBlueButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_MailPreviewPartsHeader),
      (_ctx.rcm.selectedMailFlow)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.member ? _ctx.member.company_name : `○○株式会社`), 1),
              _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.member ? _ctx.member.name : "●●") + " 様 ", 1)
            ]),
            _createVNode(_component_MailPreviewPartsEditContent, { onAddMessage: _ctx.addMessage }, null, 8, ["onAddMessage"])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_MailPreviewPartsPublicRoomTable, {
        showAnswerResults: _ctx.rcm.selectedMailFlow.show_qa
      }, null, 8, ["showAnswerResults"]),
      (_ctx.rm.userInfo)
        ? (_openBlock(), _createElementBlock("table", _hoisted_6, _hoisted_8))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_MailPreviewPartsSelectableMags, { isFix: true }),
        _createVNode(_component_MailPreviewPartsBlueButton, {
          buttonName: _ctx.rcm.room && _ctx.rcm.room.room_type == `parent_room` ? `調整ページへ` : `調整ページで日程を確認する`
        }, null, 8, ["buttonName"])
      ])
    ])
  ]))
}